var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras.groupGuestDisplay.display == 1)?_c('div',{staticClass:"m-pc-guest-info top-nav new",style:({
    background:
      _vm.extras.guestBg.colorOrBg == 'color'
        ? _vm.extras.guestBg.color
        : 'url(' + _vm.extras.guestBg.src + ')',
  }),attrs:{"id":"guest"}},[(_vm.extras.guestTitle.display == 1)?_c('Title',{attrs:{"title":_vm.extras.guestTitle.mainTitle || _vm.title,"en":_vm.extras.guestTitle.subTitle || _vm.en,"extras":_vm.extras}}):_vm._e(),_c('div',{staticClass:"g-guest-desc u-w1200"},[_c('div',{staticClass:"guest-swiper"},[(_vm.extras.guestCardStyle.style == 1)?_c('ul',{staticClass:"list"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.tempGuests),function(item,index){return _c('swiper-slide',{key:index,staticClass:"swiper-slide"},_vm._l((item),function(guest,i){return _c('div',{key:i,staticClass:"info-outer"},[_c('div',{staticClass:"seminar-guest-info",on:{"click":function($event){return _vm.showDetail(guest)}}},[_c('div',{staticClass:"head-area"},[_c('div',{staticClass:"head-outer"},[_c('img',{staticClass:"head-img",attrs:{"src":guest.realPath || _vm.defaultHeader,"alt":guest.name}}),_c('div',{staticClass:"img-bg"},[_c('img',{style:({
                          background:
                            _vm.extras.guestStyle.colorOrBg == 'color'
                              ? _vm.extras.guestStyle.color
                              : '',
                        }),attrs:{"src":_vm.extras.guestStyle.colorOrBg == 'src'
                            ? _vm.extras.guestStyle.src
                            : '',"alt":""}})]),_c('div',{staticClass:"img-bg-active"},[_c('img',{style:({
                          background:
                            _vm.extras.guestStyle.colorOrBg2 == 'color'
                              ? _vm.extras.guestStyle.color2
                              : '',
                        }),attrs:{"src":_vm.extras.guestStyle.colorOrBg2 == 'src'
                            ? _vm.extras.guestStyle.img
                            : require('../../assets/images/transparent.png'),"alt":""}})])])]),_c('div',{staticClass:"g-info-bottom",style:({
                    background:
                      _vm.extras.guestStyle.card == 'custom'
                        ? _vm.extras.guestStyle.color3
                        : '',
                  })},[(_vm.extras.guestName.display == 1)?_c('div',{staticClass:"name",style:({
                      color:
                        _vm.extras.guestName.name == 'custom'
                          ? _vm.extras.guestName.fontColor
                          : '',
                      'font-size':
                        _vm.extras.guestName.name == 'custom'
                          ? _vm.extras.guestName.fontSize + 'px'
                          : '',
                      'font-style':
                        _vm.extras.guestName.name == 'custom'
                          ? _vm.extras.guestName.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        _vm.extras.guestName.name == 'custom'
                          ? _vm.extras.guestName.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    })},[_vm._v(" "+_vm._s(guest.name)+" ")]):_vm._e(),(_vm.extras.guestEnterprise.display == 1)?_c('div',{staticClass:"position",style:({
                      color:
                        _vm.extras.guestEnterprise.enterprise == 'custom'
                          ? _vm.extras.guestEnterprise.fontColor
                          : '',
                      'font-size':
                        _vm.extras.guestEnterprise.enterprise == 'custom'
                          ? _vm.extras.guestEnterprise.fontSize + 'px'
                          : '',
                      'font-style':
                        _vm.extras.guestEnterprise.enterprise == 'custom'
                          ? _vm.extras.guestEnterprise.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        _vm.extras.guestEnterprise.enterprise == 'custom'
                          ? _vm.extras.guestEnterprise.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    })},[_vm._v(" "+_vm._s(guest.enterprise)+" ")]):_vm._e(),(_vm.extras.guestDuty.display == 1)?_c('div',{staticClass:"position center",style:({
                      color:
                        _vm.extras.guestDuty.duty == 'custom'
                          ? _vm.extras.guestDuty.fontColor
                          : '',
                      'font-size':
                        _vm.extras.guestDuty.duty == 'custom'
                          ? _vm.extras.guestDuty.fontSize + 'px'
                          : '',
                      'font-style':
                        _vm.extras.guestDuty.duty == 'custom'
                          ? _vm.extras.guestDuty.fontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        _vm.extras.guestDuty.duty == 'custom'
                          ? _vm.extras.guestDuty.fontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    })},[_vm._v(" "+_vm._s(guest.duty)+" ")]):_vm._e()])])])}),0)}),1)],1):_vm._e(),(_vm.extras.guestCardStyle.style == 2)?_c('ul',{staticClass:"list"},[_c('swiper',{attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.tempGuests2),function(item,index){return _c('swiper-slide',{key:index,staticClass:"swiper-slide"},_vm._l((item),function(guest,i){return _c('div',{key:i,staticClass:"info-outer2",class:_vm.extras.guestStyle.headType == 2 ? 'circle' : '',style:({
                background:
                  _vm.extras.guestStyle.colorOrBg == 'color'
                    ? _vm.extras.guestStyle.color
                    : 'url(' + _vm.extras.guestStyle.src + ')',
              }),on:{"click":function($event){return _vm.showDetail(guest)}}},[_c('div',{staticClass:"seminar-guest-info"},[(_vm.extras.guestName.display == 1)?_c('div',{staticClass:"name",style:({
                    color:
                      _vm.extras.guestName.name == 'custom'
                        ? _vm.extras.guestName.fontColor
                        : '',
                    'font-size':
                      _vm.extras.guestName.name == 'custom'
                        ? _vm.extras.guestName.fontSize + 'px'
                        : '',
                    'font-style':
                      _vm.extras.guestName.name == 'custom'
                        ? _vm.extras.guestName.fontTilt == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      _vm.extras.guestName.name == 'custom'
                        ? _vm.extras.guestName.fontWeight == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  })},[_vm._v(" "+_vm._s(guest.name)+" ")]):_vm._e(),_c('div',{staticClass:"spite-line low"}),(_vm.extras.guestEnterprise.display == 1)?_c('div',{staticClass:"position",style:({
                    color:
                      _vm.extras.guestEnterprise.enterprise == 'custom'
                        ? _vm.extras.guestEnterprise.fontColor
                        : '',
                    'font-size':
                      _vm.extras.guestEnterprise.enterprise == 'custom'
                        ? _vm.extras.guestEnterprise.fontSize + 'px'
                        : '',
                    'font-style':
                      _vm.extras.guestEnterprise.enterprise == 'custom'
                        ? _vm.extras.guestEnterprise.fontTilt == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      _vm.extras.guestEnterprise.enterprise == 'custom'
                        ? _vm.extras.guestEnterprise.fontWeight == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  })},[_vm._v(" "+_vm._s(guest.enterprise)+" ")]):_vm._e(),(_vm.extras.guestDuty.display == 1)?_c('div',{staticClass:"position center",style:({
                    color:
                      _vm.extras.guestDuty.duty == 'custom'
                        ? _vm.extras.guestDuty.fontColor
                        : '',
                    'font-size':
                      _vm.extras.guestDuty.duty == 'custom'
                        ? _vm.extras.guestDuty.fontSize + 'px'
                        : '',
                    'font-style':
                      _vm.extras.guestDuty.duty == 'custom'
                        ? _vm.extras.guestDuty.fontTilt == 'on'
                          ? 'italic'
                          : 'normal'
                        : '',
                    'font-Weight':
                      _vm.extras.guestDuty.duty == 'custom'
                        ? _vm.extras.guestDuty.fontWeight == 'on'
                          ? 'bolder'
                          : ''
                        : '',
                  })},[_vm._v(" "+_vm._s(guest.duty)+" ")]):_vm._e()]),_c('div',{staticClass:"head-img"},[_c('img',{attrs:{"src":guest.realPath || _vm.defaultHeader}})])])}),0)}),1)],1):_vm._e(),(_vm.guests.length > 4)?_c('div',{staticClass:"swiper-button-prev"},[_c('div',{staticClass:"delta_empty _left",style:({
            'border-color':
              _vm.extras.guestStyle.button == 'custom'
                ? _vm.extras.guestStyle.color4
                : '',
          })}),_c('div',{staticClass:"delta _left",style:({
            'border-right-color':
              _vm.extras.guestStyle.button == 'custom'
                ? _vm.extras.guestStyle.color4
                : '',
          })})]):_vm._e(),(_vm.guests.length > 4)?_c('div',{staticClass:"swiper-button-next"},[_c('div',{staticClass:"delta _right",style:({
            'border-left-color':
              _vm.extras.guestStyle.button == 'custom'
                ? _vm.extras.guestStyle.color4
                : '',
          })}),_c('div',{staticClass:"delta_empty _right",style:({
            'border-color':
              _vm.extras.guestStyle.button == 'custom'
                ? _vm.extras.guestStyle.color4
                : '',
          })})]):_vm._e()]),(_vm.guests.length == 0)?_c('div',{staticClass:"m-nodata-body"},[_c('img',{attrs:{"src":require("@/assets/images/nodata.png")}}),_c('div',{staticClass:"m-nodata"},[_vm._v("暂无数据")])]):_vm._e()]),(_vm.isShowDetail)?_c('div',{staticClass:"guest-detail-bg"},[_c('div',{staticClass:"detail-info"},[_c('div',{staticClass:"close"},[_c('span',{staticClass:"icon icontemp stemp-close",on:{"click":function($event){_vm.isShowDetail = false}}})]),_c('div',{staticClass:"base-info"},[(_vm.extras.guestName.display == 1)?_c('div',{staticClass:"name",style:({
            color:
              _vm.extras.guestName.name == 'custom'
                ? _vm.extras.guestName.fontColor
                : '',
            'font-size':
              _vm.extras.guestName.name == 'custom'
                ? _vm.extras.guestName.fontSize + 'px'
                : '',
            'font-style':
              _vm.extras.guestName.name == 'custom'
                ? _vm.extras.guestName.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.guestName.name == 'custom'
                ? _vm.extras.guestName.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_vm._v(" "+_vm._s(_vm.currentGuest.name)+" ")]):_vm._e(),_c('div',{staticClass:"spite-line"}),(_vm.extras.guestEnterprise.display == 1)?_c('div',{staticClass:"content",style:({
            color:
              _vm.extras.guestEnterprise.enterprise == 'custom'
                ? _vm.extras.guestEnterprise.fontColor
                : '',
            'font-size':
              _vm.extras.guestEnterprise.enterprise == 'custom'
                ? _vm.extras.guestEnterprise.fontSize + 'px'
                : '',
            'font-style':
              _vm.extras.guestEnterprise.enterprise == 'custom'
                ? _vm.extras.guestEnterprise.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.guestEnterprise.enterprise == 'custom'
                ? _vm.extras.guestEnterprise.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_vm._v(" 公司："),_c('span',[_vm._v(_vm._s(_vm.currentGuest.enterprise))])]):_vm._e(),(_vm.extras.guestDuty.display == 1)?_c('div',{staticClass:"content",style:({
            color:
              _vm.extras.guestDuty.duty == 'custom'
                ? _vm.extras.guestDuty.fontColor
                : '',
            'font-size':
              _vm.extras.guestDuty.duty == 'custom'
                ? _vm.extras.guestDuty.fontSize + 'px'
                : '',
            'font-style':
              _vm.extras.guestDuty.duty == 'custom'
                ? _vm.extras.guestDuty.fontTilt == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.guestDuty.duty == 'custom'
                ? _vm.extras.guestDuty.fontWeight == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_vm._v(" 职位："),_c('span',[_vm._v(_vm._s(_vm.currentGuest.duty))])]):_vm._e(),(_vm.currentGuest.intro)?_c('div',{staticClass:"content"},[_vm._v(" 简介："),_c('span',[_vm._v(_vm._s(_vm.currentGuest.intro))])]):_vm._e()]),_c('div',{staticClass:"head-img"},[_c('img',{attrs:{"src":_vm.currentGuest.realPath || _vm.defaultHeader,"alt":_vm.currentGuest.name}})])])]):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }